import en from './en.json'
import se from './se.json'

export default {
  en,
  se
}